import { Spinner } from "react-bootstrap";

const Loader = () => {
  return (
    <div className="justify-content-center loader-body">
      <Spinner animation="border" variant="primary" />
    </div>
  );
};

export default Loader;
